const clientSubscriptionData = {
  config: {
    errors: {},
    isSaving: false,
    contractLoaded: false,
    emailIsLoading: false,
    prefilledEmail: {
      status: false,
      message: '',
    },
    siretIsLoading: false,
    siretIsValid: false,
    newsletterData: {},
    newsletterLoading: false,
    newsletterError: '',
    newsletterCanBeSent: true,
    isValidZohoId: false,
    isMcpClient: false,
    isMcpLocked: false,
    mcpUnlockError: null,
  },
  personal: {
    zohoId: null,
    firstName: null,
    firstName2: null,
    lastName: null,
    lastName2: null,
    birthdate: null,
    civility: null,
    civility2: null,
    email: null,
    phone1: null,
    phone2: null,
    secondName: null,
  },
  preferences: {
    clientType: null,
    dataCollectionAuth: false,
    neverBounceResult: null,
    isNewsletterRegistered: false,
    isEkomiRegistered: false,
    createEkomiInteraction: null,
    whatsappInteraction: false,
    callbackDate: null,
    callbackTime: null,
    bacVoucher: false,
  },
  professional: {
    socialReason: null,
    siret: null,
    activity: null,
    apeCode: null,
    taxId: null,
  },
  additional: {
    comments: null,
    createdAt: null,
    referral: null,
    referralFirstName: null,
    referralLastName: null,
  },
}

export default clientSubscriptionData
